import {ChevronLeftIcon} from '@/components/Icons';
import {getGlobalButtons} from '@/services/content/appContent';
import {twx} from '@/utils/tailwindUtils';

import ButtonRaw from './ButtonRaw';

type BackButtonProps = React.ComponentProps<typeof ButtonRaw> & {
    icon?: React.ReactNode;
    alt?: string;
};

const BackButton = ({className, icon, alt, ref, ...restProps}: BackButtonProps) => (
    <ButtonRaw
        ref={ref}
        data-testid='back-button'
        className={twx(
            'flex h-11 w-11 items-center justify-center rounded-full border-0 bg-transparent p-0 text-white outline-none',
            className
        )}
        aria-label={alt ?? getGlobalButtons().backButton?.alt ?? undefined}
        {...restProps}
    >
        {icon ?? <ChevronLeftIcon />}
    </ButtonRaw>
);

BackButton.displayName = 'BackButton';

export default BackButton;
